import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1 : [
  {
    column: "column1",
    columnWidth : "100%",
    rows: {
      row1: [
        {
          name: "InBond Details",
          actionText: "InBond Details:",
          component: "typographyText",
        },
      ],
      row2: [
        {
          name: "InBond'sInvSNO",
          label: "InBond's Inv SNO",
          component: "text-field",
          width:"50%"
          
        },
        {
          name: "InBond'sItemSNO",
          label: "InBond's Item SNO",
          component: "text-field",
           width:"50%"

        },
      ],
    },
  },
]
};
